import {
  ComposedChart, Area, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
} from "recharts";
import { formatCompact, formatCurrency } from "@/lib/format";

const Box = ({ title, subtitle, children }) => (
  <div className="bg-white rounded-2xl border border-[#E8E3D9] p-5 sm:p-6 shadow-sm">
    <div className="mb-4">
      <h3 className="font-heading text-lg font-bold text-[#1A231F]">{title}</h3>
      {subtitle && <p className="text-xs text-[#8A9790] mt-0.5">{subtitle}</p>}
    </div>
    {children}
  </div>
);

export const IncomeVsExpenses = ({ result, currency }) => {
  const data = (result.projection || []).map((p) => ({
    age: p.age,
    other: Math.round((p.otherIncome || 0) / 12),
    swp: Math.round((p.withdrawal || 0) / 12),
    expense: Math.round((p.expense || 0) / 12),
  }));

  return (
    <Box title="Monthly income vs expenses" subtitle="Other income + corpus SWP stacked against your monthly spend, through retirement">
      <div className="h-72" data-testid="income-vs-expenses">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={data} margin={{ top: 10, right: 8, left: 4, bottom: 0 }}>
            <defs>
              <linearGradient id="incOther" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#2A6F7F" stopOpacity={0.85} />
                <stop offset="100%" stopColor="#2A6F7F" stopOpacity={0.5} />
              </linearGradient>
              <linearGradient id="incSwp" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#2D6A4F" stopOpacity={0.85} />
                <stop offset="100%" stopColor="#2D6A4F" stopOpacity={0.5} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#EFE9DD" vertical={false} />
            <XAxis dataKey="age" tick={{ fontSize: 11, fill: "#8A9790" }} tickLine={false} axisLine={{ stroke: "#E8E3D9" }} />
            <YAxis tickFormatter={(v) => formatCompact(v, currency)} tick={{ fontSize: 11, fill: "#8A9790" }} tickLine={false} axisLine={false} width={64} />
            <Tooltip
              formatter={(v, n) => [formatCurrency(v, currency), n]}
              labelFormatter={(a) => `Age ${a}`}
              contentStyle={{ borderRadius: 12, border: "1px solid #E8E3D9", fontSize: 12 }}
            />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Area type="monotone" dataKey="other" name="Other income" stackId="1" stroke="#2A6F7F" fill="url(#incOther)" />
            <Area type="monotone" dataKey="swp" name="Corpus SWP" stackId="1" stroke="#2D6A4F" fill="url(#incSwp)" />
            <Line type="monotone" dataKey="expense" name="Expenses" stroke="#D96B43" strokeWidth={2.5} dot={false} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </Box>
  );
};
